import React, { useEffect, useRef, useState } from 'react';
// Import static images 
import Menu from "../assets/images/Menu.svg";
import logo from "../assets/images/authenteklogo.png"
// Import js files
import Header from './HorizontalLayout/Header';
import Navbar from './HorizontalLayout/Navbar';
import Footer from './HorizontalLayout/Footer';
import Menubar from './HorizontalLayout/Menubar';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import LanguageSwitcher from "../LanguageSwitcher/languageSwitcher";



const Layout = ({ title, children, isRedirected = false }) => {
    const allCompanysitedata = useSelector((state) => state.allDashboardReducer.companysite);
    const Sitename = allCompanysitedata && allCompanysitedata.siteName;
    const [isOpen, setIsOpen] = useState(false);
    const { pathname } = useLocation()

    useEffect(() => {
        (window.innerWidth < 1024 && pathname === '/QR' && isRedirected) ? setIsOpen(true) : setIsOpen(false)
    }, [window.innerWidth])

    const handleClose = () => { setIsOpen(false) }
    const handleOpen = () => { setIsOpen(true) }
    return (
        <React.Fragment>
            <div className={["layoutSidenav", isOpen ? "sidebar-small" : ""].join(" ")}>
                <div className="layoutSidenav_nav position-relative">
                    <Header isSideBaropen={isOpen} handleClose={handleClose} handleOpen={handleOpen} />
                    <Navbar /> </div>
                <div className="layout-page">
                    <div className="header-section d-flex align-items-center">
                        <h4 className="mbnone">{Sitename}</h4>
                        {/* <h4 className="mbnone">{title == "Dashboard" ? "Dashboard" : {Sitename}}</h4>*/}
                        <button className="mb-hamburger" onClick={handleOpen}><img src={Menu}></img> </button>
                        <div className="mb-logo mobile-side-logo">
                            <a href="#"><img src={logo}></img></a>
                        </div>
                        <div className="ms-auto d-flex align-items-center gap-3">
                            <LanguageSwitcher />
                           {/* <div className='desktopView'>*/}
                                <Menubar />
                           {/* </div>*/}
                        </div>
                    </div>
                    <div className="main-section">
                        <div className={title == "Dashboard" ? "card-box-new" : "card-box"}> {children} </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
export default Layout;
